import P from '../../pages';
import { generateProfileElementObject, changeState } from '../../utilities';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import ButtonGroup from './ButtonGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import ReactMarkdown from 'react-markdown';
import CustomFormGroup from './CustomFormGroup';
import { validator, fieldsToValidate, pageValid, executeValidations } from '../../validator';

class References extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      referee1Name: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','lifestyle','referee_1', 'name'),
      referee1Email: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','lifestyle','referee_1', 'email'),
      referee1Phone: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','lifestyle','referee_1', 'phone'),
      referee1Relationship: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','lifestyle','referee_1', 'relationship'),
      referee2Name: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','lifestyle','referee_2', 'name'),
      referee2Email: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','lifestyle','referee_2', 'email'),
      referee2Phone: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','lifestyle','referee_2', 'phone'),
      referee2Relationship: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','lifestyle','referee_2', 'relationship'),
     };
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
    this.field = this.field.bind(this);
    this.changeState = this.changeState.bind(this);
  }

  componentWillMount(){
    executeValidations(this)
  }

  changeState = async(id, val) => {
    changeState(this, id, val)
  }

  back(e) {
    e.preventDefault();
    this.props.onGoBack();
  }

  submit(e) {
    this.props.onHostProfileSubmit({
      lifestyle: {
        referee_1: {
          name: this.state.referee1Name.val,
          relationship: this.state.referee1Relationship.val,
          phone: this.state.referee1Phone.val,
          email: this.state.referee1Email.val,
        },
        referee_2: {
          name: this.state.referee2Name.val,
          relationship: this.state.referee2Relationship.val,
          phone: this.state.referee2Phone.val,
          email: this.state.referee2Email.val,
        }
      }
    });
  }

  field(num, key) {
    const newKey = `referee${num}${key}`;

    return (
      <CustomFormGroup valid={this.state[newKey].valid}>
        <FormControl
          id={newKey}
          type="text"
          style={{width: '100%'}}
          componentClass="input"
          onChange={e => this.changeState(e.target.id, e.target.value)}
          placeholder={this.props.intl.formatMessage(defaultMessages["clientHostPagesReferencesPlaceholders" + key])}
          defaultValue={this.state[newKey].val}
        />
      </CustomFormGroup>
    )
  }

  render() {
    const thisPage = P.REFERENCES_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;

    return (
      <div id={page} className='profile'>
        <Redirector this_page={thisPage} page={page}/>

        <form onSubmit={this.submit}>
          <FormHeader title={content.pages.references.title}/>
          <ReactMarkdown source={content.pages.references.body}/>

          <ControlLabel>{formatMessage(defaultMessages.clientHostPagesReferencesLabelsReferee1)}</ControlLabel>
          {this.field(1, 'Name')}
          {this.field(1, 'Phone')}
          {this.field(1, 'Email')}
          {this.field(1, 'Relationship')}

          <ControlLabel>{formatMessage(defaultMessages.clientHostPagesReferencesLabelsReferee2)}</ControlLabel>
          {this.field(2, 'Name')}
          {this.field(2, 'Phone')}
          {this.field(2, 'Email')}
          {this.field(2, 'Relationship')}

          <ButtonGroup
            backFunc={this.back}
            submitFunc={this.submit}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl}
            disableSubmit={!pageValid(this.state, this.props.requiredFields)}
          />

        </form>
      </div>
    );
  }
}

References.propTypes = {
   onHostProfileSubmit: PropTypes.func,
   onSkipSubmit: PropTypes.func,
   onGoBack: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};

export default injectIntl(References);
